import React from "react";
import { Box, Grid } from "@tiny/components";
import AudienceList from "../../components/AudienceList/AudienceList";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import SubscribersBySourceStats from "../../components/SubscribersBySourceStats";
import SubscribersByISPStats from "../../components/SubscribersByISPStats";
import AudienceStats from "./AudienceStats";

function AudienceSources() {
  const { mdUp, lgUp } = useBreakpoints();

  return (
    <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
      <Grid item xs={12}>
        <AudienceStats />
      </Grid>
      <Grid item xs={12} md={6}>
        <SubscribersBySourceStats />
      </Grid>
      <Grid item xs={12} md={6}>
        <SubscribersByISPStats />
      </Grid>
      <Grid item xs={12}>
        <Box
          bgcolor="white"
          p={{ xs: 5, md: 6 }}
          borderRadius={mdUp ? "8px" : "0px"}
        >
          <AudienceList
            segmentTypes={["INTEGRATION", "UPLOAD"]}
            enableBulkDelete
            seeAllSubcribersOnUpload
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default AudienceSources;
